export interface Comic {
  id: string;
  title: string;
  cover: string;
  author: string;
  category: string;
  status: "连载中" | "已完结";
  tags: string[];
  intro: string;
  rating: number;
  views: string;
  follows: number;
  updated: string;
  chapters: string[];
}

export const categories = [
  "全部",
  "热血冒险",
  "玄幻仙侠",
  "都市异能",
  "科幻机甲",
  "奇幻魔法",
  "悬疑推理",
  "恋爱治愈",
  "美食日常",
];

export const comics: Comic[] = [
  {
    id: "xingqiong",
    title: "星穹之约",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20of%20two%20young%20space%20travelers%20standing%20before%20a%20glowing%20teal%20nebula%2C%20vibrant%20orange%20and%20teal%20palette%2C%20dynamic%20pose%2C%20sci-fi%20adventure%20comic%20book%20cover%20illustration%2C%20clean%20lineart%2C%20cinematic%20lighting%2C%20high%20detail&width=600&height=800&seq=comic-01&orientation=portrait",
    author: "林澈",
    category: "科幻机甲",
    status: "连载中",
    tags: ["星际", "冒险", "热血"],
    intro: "少年飞行员阿遥驾驶破旧星舰,在广袤星海中寻找失落的故乡坐标。每一次跃迁,都是一场与未知的赌约。",
    rating: 9.2,
    views: "1.2亿",
    follows: 482000,
    updated: "3小时前",
    chapters: [
      "第1话 破碎的坐标",
      "第2话 跃迁之赌",
      "第3话 星盗来袭",
      "第4话 废弃星港",
      "第5话 记忆碎片",
      "第6话 虚空之眼",
      "第7话 双子行星",
      "第8话 反叛的火种",
      "第9话 光年之外",
      "第10话 星穹之门",
    ],
  },
  {
    id: "jianying",
    title: "剑影苍穹",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20young%20swordswoman%20in%20flowing%20robes%20under%20a%20stormy%20sky%20with%20a%20glowing%20blade%2C%20wuxia%20fantasy%20comic%20illustration%2C%20ink%20and%20wash%20style%2C%20dramatic%20composition%2C%20warm%20orange%20lighting%20against%20cool%20clouds%2C%20high%20detail&width=600&height=800&seq=comic-02&orientation=portrait",
    author: "顾清玄",
    category: "玄幻仙侠",
    status: "连载中",
    tags: ["武侠", "御剑", "宗门"],
    intro: "剑阁没落弟子沈剑一,身负一枚残破剑印。当苍穹裂开第一道缝隙,他拾起的将是整个江湖的命运。",
    rating: 9.5,
    views: "2.8亿",
    follows: 716000,
    updated: "2小时前",
    chapters: [
      "第1话 残剑入鞘",
      "第2话 风雪剑阁",
      "第3话 剑气纵横",
      "第4话 山门之约",
      "第5话 断剑重铸",
      "第6话 苍龙现世",
      "第7话 万剑朝宗",
      "第8话 血战北疆",
      "第9话 剑心通明",
      "第10话 苍穹裂变",
    ],
  },
  {
    id: "chengshi",
    title: "都市异能录",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20modern%20city%20at%20night%20with%20glowing%20energy%20anomalies%20and%20a%20silhouetted%20figure%20with%20electric%20powers%2C%20urban%20supernatural%20comic%20illustration%2C%20neon%20orange%20and%20teal%20accents%2C%20mysterious%20atmosphere%2C%20high%20detail&width=600&height=800&seq=comic-03&orientation=portrait",
    author: "陆行舟",
    category: "都市异能",
    status: "已完结",
    tags: ["异能", "都市", "热血"],
    intro: "普通上班族叶落一夜之间觉醒念力,也卷入城市暗面的一场异能风暴。平凡外壳下,藏着怎样惊天的秘密?",
    rating: 8.8,
    views: "9800万",
    follows: 326000,
    updated: "3天前",
    chapters: [
      "第1话 雨夜觉醒",
      "第2话 念力失控",
      "第3话 城市结界",
      "第4话 组织代号",
      "第5话 灰色地带",
      "第6话 追逐战",
      "第7话 记忆之墙",
      "第8话 异能联盟",
      "第9话 决战天台",
      "第10话 终局",
    ],
  },
  {
    id: "huanling",
    title: "幻灵学院",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20bright%20magical%20academy%20with%20floating%20spirit%20creatures%20and%20a%20cheerful%20girl%20summoning%20a%20cute%20spirit%2C%20fantasy%20school%20comic%20illustration%2C%20colorful%20warm%20palette%2C%20playful%20and%20whimsical%2C%20high%20detail&width=600&height=800&seq=comic-04&orientation=portrait",
    author: "苏晚晴",
    category: "奇幻魔法",
    status: "连载中",
    tags: ["魔法", "校园", "萌系"],
    intro: "笨手笨脚的少女铃兰考进传说中的幻灵学院,第一堂课就放出了一只谁都管不住的神级小精灵。",
    rating: 9.0,
    views: "1.5亿",
    follows: 521000,
    updated: "5小时前",
    chapters: [
      "第1话 开学典礼",
      "第2话 失控的小精灵",
      "第3话 初级驯灵课",
      "第4话 学院祭",
      "第5话 禁林试炼",
      "第6话 契约之绊",
      "第7话 天空竞技场",
      "第8话 秘宝之谷",
      "第9话 觉醒时刻",
      "第10话 双月之夜",
    ],
  },
  {
    id: "shanhai",
    title: "山海食堂",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20cozy%20chinese%20fantasy%20restaurant%20with%20steaming%20delicious%20food%20and%20cute%20mythical%20beast%20customers%2C%20warm%20homely%20lighting%2C%20food%20comic%20illustration%2C%20gentle%20and%20heartwarming%2C%20rich%20color%2C%20high%20detail&width=600&height=800&seq=comic-05&orientation=portrait",
    author: "白鹿",
    category: "美食日常",
    status: "连载中",
    tags: ["美食", "治愈", "奇幻"],
    intro: "深夜的山海街角,开着一家只招待神兽的小食堂。一碗热汤下肚,连传说都会露出满足的表情。",
    rating: 9.3,
    views: "1.8亿",
    follows: 604000,
    updated: "1小时前",
    chapters: [
      "第1话 深夜食堂",
      "第2话 九尾狐的甜品",
      "第3话 饕餮的盛宴",
      "第4话 鲛人的眼泪",
      "第5话 麒麟的心愿",
      "第6话 灶神归来",
      "第7话 百草汤",
      "第8话 山海年味",
      "第9话 龙须面",
      "第10话 月圆之约",
    ],
  },
  {
    id: "anzhen",
    title: "暗夜侦探社",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20mysterious%20detective%20with%20a%20magnifying%20glass%20in%20a%20noir%20rainy%20city%20street%2C%20moody%20dark%20teal%20and%20amber%20lighting%2C%20suspense%20mystery%20comic%20illustration%2C%20film%20noir%20atmosphere%2C%20high%20detail&width=600&height=800&seq=comic-06&orientation=portrait",
    author: "陈默",
    category: "悬疑推理",
    status: "连载中",
    tags: ["推理", "悬疑", "暗黑"],
    intro: "只有晚上才营业的侦探社,专接见不得光的案子。当一桩连环谜案把侦探少年拖入深渊,真相愈发扑朔迷离。",
    rating: 9.4,
    views: "1.1亿",
    follows: 458000,
    updated: "昨天",
    chapters: [
      "第1话 午夜委托",
      "第2话 消失的钥匙",
      "第3话 双面证词",
      "第4话 迷雾剧场",
      "第5话 反向推理",
      "第6话 无声的目击者",
      "第7话 红月谜案",
      "第8话 最后的信",
      "第9话 真相之门",
      "第10话 黎明之前",
    ],
  },
  {
    id: "jixie",
    title: "机械之心",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20determined%20girl%20in%20a%20mecha%20suit%20with%20glowing%20engine%20core%2C%20robotic%20mecha%20comic%20illustration%2C%20orange%20glow%20against%20steel%20blue%2C%20dynamic%20mecha%20combat%20pose%2C%20high%20detail&width=600&height=800&seq=comic-07&orientation=portrait",
    author: "韩东",
    category: "科幻机甲",
    status: "已完结",
    tags: ["机甲", "末世", "燃"],
    intro: "废土纪元,少女林晓晓捡到一台沉睡的机甲。当世界面临终结,她将驾驶机械之心守护最后的文明。",
    rating: 8.7,
    views: "8600万",
    follows: 287000,
    updated: "1周前",
    chapters: [
      "第1话 苏醒",
      "第2话 初代机",
      "第3话 废土试炼",
      "第4话 钢铁洪流",
      "第5话 核心过热",
      "第6话 战友",
      "第7话 最后的城市",
      "第8话 反攻之日",
      "第9话 终焉引擎",
      "第10话 新生",
    ],
  },
  {
    id: "shikong",
    title: "时空旅人",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20time%20traveler%20stepping%20through%20a%20glowing%20portal%20between%20different%20eras%2C%20surreal%20dreamlike%20fantasy%20comic%20illustration%2C%20warm%20and%20cool%20color%20blend%2C%20mystical%20atmosphere%2C%20high%20detail&width=600&height=800&seq=comic-08&orientation=portrait",
    author: "江南旧梦",
    category: "奇幻魔法",
    status: "连载中",
    tags: ["时空", "穿越", "治愈"],
    intro: "能穿越时间的老钟表匠,每次拨动表盘都改写一段遗憾。可他自己的终点,却始终无法抵达。",
    rating: 8.9,
    views: "7200万",
    follows: 214000,
    updated: "6小时前",
    chapters: [
      "第1话 老钟表铺",
      "第2话 一秒之差",
      "第3话 逆转的夏日",
      "第4话 平行世界的信",
      "第5话 被遗忘的人",
      "第6话 时间的重量",
      "第7话 故乡的重逢",
      "第8话 指针停摆",
      "第9话 永不完结的故事",
      "第10话 回到原点",
    ],
  },
  {
    id: "longzu",
    title: "龙族之裔",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20fierce%20dragon%20lord%20and%20a%20young%20heir%20with%20golden%20eyes%20amid%20storm%20clouds%2C%20epic%20fantasy%20dragon%20comic%20illustration%2C%20dramatic%20warm%20orange%20and%20deep%20green%2C%20majestic%20scale%2C%20high%20detail&width=600&height=800&seq=comic-09&orientation=portrait",
    author: "墨染",
    category: "玄幻仙侠",
    status: "连载中",
    tags: ["龙族", "传承", "史诗"],
    intro: "龙族湮灭百年后,一个少年在荒漠醒来,体内流淌着最后一滴真龙之血。他背负的,是整个龙族的荣光与罪。",
    rating: 9.1,
    views: "2.3亿",
    follows: 689000,
    updated: "4小时前",
    chapters: [
      "第1话 荒漠觉醒",
      "第2话 真龙之血",
      "第3话 龙语传承",
      "第4话 猎龙者",
      "第5话 云巅龙宫",
      "第6话 逆鳞",
      "第7话 五爪现世",
      "第8话 屠龙之战",
      "第9话 祖龙之魂",
      "第10话 苍穹龙吟",
    ],
  },
  {
    id: "yuling",
    title: "御灵少女",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20sweet%20girl%20summoning%20colorful%20guardian%20spirits%20with%20cherry%20blossoms%2C%20light%20fantasy%20comic%20illustration%2C%20soft%20pastel%20warm%20palette%2C%20gentle%20magical%20glow%2C%20adorable%20style%2C%20high%20detail&width=600&height=800&seq=comic-10&orientation=portrait",
    author: "桃桃",
    category: "奇幻魔法",
    status: "连载中",
    tags: ["御灵", "少女", "甜宠"],
    intro: "继承了祖母御灵天赋的少女,在樱花盛开的季节唤醒第一只守护灵。这场温柔的奇遇,才刚刚开始。",
    rating: 9.0,
    views: "1.4亿",
    follows: 533000,
    updated: "30分钟前",
    chapters: [
      "第1话 樱花与灵",
      "第2话 第一只守护灵",
      "第3话 灵契",
      "第4话 校园风波",
      "第5话 春日祭",
      "第6话 苏醒的力量",
      "第7话 灵界之门",
      "第8话 守护之心",
      "第9话 花语",
      "第10话 与你同行",
    ],
  },
  {
    id: "chongsheng",
    title: "重生千金",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20an%20elegant%20determined%20young%20woman%20in%20modern%20fashion%20with%20a%20confident%20smile%2C%20romance%20drama%20comic%20illustration%2C%20soft%20warm%20golden%20and%20rose%20tones%2C%20stylish%20and%20refined%2C%20high%20detail&width=600&height=800&seq=comic-11&orientation=portrait",
    author: "荔枝甜",
    category: "恋爱治愈",
    status: "已完结",
    tags: ["重生", "复仇", "甜爽"],
    intro: "重活一世的世家千金,决心改写被算计的人生。这一世,她要把失去的都夺回来,把错过的人都好好珍惜。",
    rating: 8.6,
    views: "6700万",
    follows: 198000,
    updated: "5天前",
    chapters: [
      "第1话 再世为人",
      "第2话 步步为营",
      "第3话 家宴风波",
      "第4话 联手",
      "第5话 商业反击",
      "第6话 真相",
      "第7话 爱意渐浓",
      "第8话 危机再临",
      "第9话 破局",
      "第10话 圆满",
    ],
  },
  {
    id: "meishi",
    title: "美食猎人",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20an%20adventurous%20chef%20hunting%20for%20legendary%20ingredients%20in%20a%20fantasy%20world%2C%20gourmet%20adventure%20comic%20illustration%2C%20vibrant%20appetizing%20food%20colors%2C%20dynamic%20and%20fun%2C%20high%20detail&width=600&height=800&seq=comic-12&orientation=portrait",
    author: "大厨阿亮",
    category: "美食日常",
    status: "连载中",
    tags: ["美食", "冒险", "燃"],
    intro: "为寻找传说中的“百味之匙”,少年厨师踏遍大陆,用一口锅征服了巨龙,也用一碗面温暖了无数旅人。",
    rating: 9.2,
    views: "1.6亿",
    follows: 572000,
    updated: "昨天",
    chapters: [
      "第1话 百味之匙",
      "第2话 铁锅出征",
      "第3话 辣味火山",
      "第4话 汤泉精灵",
      "第5话 龙肉料理",
      "第6话 甜点幻境",
      "第7话 深海的盐",
      "第8话 决战食神",
      "第9话 家乡的味道",
      "第10话 终焉之宴",
    ],
  },
  {
    id: "zhoushu",
    title: "咒术校园",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20mysterious%20school%20with%20occult%20symbols%20and%20a%20determined%20student%20holding%20a%20glowing%20talisman%2C%20occult%20school%20comic%20illustration%2C%20dark%20teal%20and%20orange%20glow%2C%20eerie%20yet%20stylish%2C%20high%20detail&width=600&height=800&seq=comic-13&orientation=portrait",
    author: "夜行",
    category: "悬疑推理",
    status: "连载中",
    tags: ["咒术", "校园", "暗黑"],
    intro: "一所藏着咒术秘密的高中,新来的转学生能看见常人看不见的“影”。当诅咒蔓延,他们能否守住这座校园?",
    rating: 8.9,
    views: "9900万",
    follows: 376000,
    updated: "3小时前",
    chapters: [
      "第1话 看得见影子的少年",
      "第2话 咒印初现",
      "第3话 禁咒教室",
      "第4话 影之低语",
      "第5话 社团秘密",
      "第6话 封印仪式",
      "第7话 失控的咒",
      "第8话 破咒之人",
      "第9话 校园的真相",
      "第10话 黎明咒歌",
    ],
  },
  {
    id: "xinghe",
    title: "星河舰队",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20fleet%20of%20warships%20amid%20an%20asteroid%20field%20with%20a%20young%20captain%20on%20the%20bridge%2C%20space%20fleet%20comic%20illustration%2C%20orange%20engines%20against%20dark%20space%20teal%2C%20epic%20scale%2C%20high%20detail&width=600&height=800&seq=comic-14&orientation=portrait",
    author: "周天行",
    category: "科幻机甲",
    status: "连载中",
    tags: ["星际", "战争", "燃"],
    intro: "银河边境战火再起,菜鸟舰长临危受命。一个连护航编队都带不好的少年,要如何撑起整个星系的未来?",
    rating: 9.0,
    views: "1.3亿",
    follows: 461000,
    updated: "8小时前",
    chapters: [
      "第1话 临危受命",
      "第2话 菜鸟舰长",
      "第3话 首航",
      "第4话 边境遇袭",
      "第5话 火力不足",
      "第6话 战术大师",
      "第7话 破晓之战",
      "第8话 军魂",
      "第9话 星际和平",
      "第10话 新的航线",
    ],
  },
];